import { Box, Heading } from 'native-base';
import React, { memo } from 'react';
const NewLoanInProgressHeader = _ref => {
  let {
    header
  } = _ref;
  return /*#__PURE__*/React.createElement(Box, null, /*#__PURE__*/React.createElement(Heading, {
    fontSize: "sm",
    fontWeight: "bold",
    fontFamily: "body",
    accessibilityLabel: header,
    testID: header
  }, header));
};
export default /*#__PURE__*/memo(NewLoanInProgressHeader);
//# sourceMappingURL=index.js.map